import styled from 'styled-components';
import { Button, Row } from '@cuemath/comps';

export {
  Container,
  LeftPanel,
  RightPanel,
  EmptyState,
} from '../dispositions/styled-comps';

export const ListItem = styled(Row)`
  && {
    padding: 10px 16px;
    font-size: 13px;
    color: ${({ $selected }) => ($selected ? '#0177ff' : '#2b2b2b')};
    background: ${({ $selected }) => ($selected ? '#E8F0FE' : 'transparent')};
    cursor: pointer;
    border-left: 3px solid ${({ $selected }) => ($selected ? '#0177ff' : 'transparent')};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &&:hover {
    background: ${({ $selected }) => ($selected ? '#E8F0FE' : '#f5f5f5')};
  }
`;

export const WriteBadge = styled.span`
  background: #fff3e0;
  color: #e65100;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 600;
`;

export const DetailPanel = styled.div`
  padding: 20px;
`;

export const ToolName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #2b2b2b;
`;

export const ToolDescription = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 20px 0;
`;

export const ParamSection = styled.div`
  margin-bottom: 20px;
`;

export const ParamLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  margin-bottom: 4px;
`;

export const ParamInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;

export const ParamHint = styled.span`
  font-size: 11px;
  color: #999;
`;

export const RunButton = styled(Button)`
  && {
    background: #0177ff;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    height: auto;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }

  &&:hover {
    background: #0060d0;
    border: none;
  }

  &&:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const ConfirmRow = styled(Row)`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    font-size: 13px;
    color: #e65100;
  }
`;

export const ResultBox = styled.pre`
  background: #1a1a1a;
  color: #e0ddd5;
  padding: 16px;
  border-radius: 8px;
  font-size: 12px;
  overflow-x: auto;
  max-height: 400px;
  overflow-y: auto;
  margin-top: 16px;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ResultMeta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 8px;
`;

export const RequiredMark = styled.span`
  color: #e65100;
`;
